import type { CSSProperties } from 'react';

const LockIcon = () => (
  <svg viewBox="0 0 60 68" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic1-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0d1f3c"/>
        <stop offset="100%" stopColor="#0a1628"/>
      </linearGradient>
      <linearGradient id="ic1-bd" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#60c8ff"/>
        <stop offset="50%" stopColor="#3b82f6"/>
        <stop offset="100%" stopColor="#1e40af"/>
      </linearGradient>
      <linearGradient id="ic1-sh" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#fff" stopOpacity="0.18"/>
        <stop offset="100%" stopColor="#fff" stopOpacity="0"/>
      </linearGradient>
      <filter id="ic1-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <path d="M30 4 L6 12 L6 35 C6 51 18 63 30 67 C42 63 54 51 54 35 L54 12 Z" fill="url(#ic1-bg)"/>
    <path d="M30 4 L6 12 L6 35 C6 51 18 63 30 67 C42 63 54 51 54 35 L54 12 Z"
      fill="none" stroke="url(#ic1-bd)" strokeWidth="1.5" filter="url(#ic1-glow)"/>
    <path d="M30 7 L9 14 L9 24 C13 21 21 18 30 17 C39 18 47 21 51 24 L51 14 Z" fill="url(#ic1-sh)"/>
    <rect x="21" y="35" width="18" height="14" rx="2.5" fill="#3b82f6" opacity="0.95"/>
    <path d="M24 35 L24 30 C24 26 36 26 36 30 L36 35"
      fill="none" stroke="#60a5fa" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="30" cy="42" r="2.5" fill="#0d1f3c"/>
    <rect x="28.8" y="42" width="2.4" height="4" rx="1" fill="#0d1f3c"/>
  </svg>
);

const HeadIcon = () => (
  <svg viewBox="0 0 60 60" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic5-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1f0718"/>
        <stop offset="100%" stopColor="#140410"/>
      </linearGradient>
      <linearGradient id="ic5-bd" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f9a8d4"/>
        <stop offset="50%" stopColor="#ec4899"/>
        <stop offset="100%" stopColor="#9d174d"/>
      </linearGradient>
      <filter id="ic5-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <filter id="ic5-ng">
        <feGaussianBlur stdDeviation="1.2" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <clipPath id="ic5-clip">
        <path d="M30 4 C18 4 9 13 9 25 C9 33 13 40 20 44 L20 50 C20 52 22 54 24 54 L36 54 C38 54 40 52 40 50 L40 44 C47 40 51 33 51 25 C51 13 42 4 30 4 Z"/>
      </clipPath>
    </defs>
    <path d="M30 4 C18 4 9 13 9 25 C9 33 13 40 20 44 L20 50 C20 52 22 54 24 54 L36 54 C38 54 40 52 40 50 L40 44 C47 40 51 33 51 25 C51 13 42 4 30 4 Z"
      fill="url(#ic5-bg)"/>
    <g clipPath="url(#ic5-clip)">
      <line x1="22" y1="20" x2="38" y2="20" stroke="#ec4899" strokeWidth="1" opacity="0.35"/>
      <line x1="22" y1="20" x2="30" y2="31" stroke="#ec4899" strokeWidth="1" opacity="0.4"/>
      <line x1="38" y1="20" x2="30" y2="31" stroke="#ec4899" strokeWidth="1" opacity="0.4"/>
      <line x1="30" y1="31" x2="21" y2="42" stroke="#ec4899" strokeWidth="1" opacity="0.4"/>
      <line x1="30" y1="31" x2="39" y2="42" stroke="#ec4899" strokeWidth="1" opacity="0.4"/>
      <circle cx="22" cy="20" r="3" fill="#ec4899" filter="url(#ic5-ng)"/>
      <circle cx="38" cy="20" r="3" fill="#ec4899" filter="url(#ic5-ng)"/>
      <circle cx="30" cy="31" r="4" fill="#ec4899" filter="url(#ic5-ng)"/>
      <circle cx="30" cy="31" r="2" fill="#f9a8d4"/>
      <circle cx="21" cy="42" r="3" fill="#ec4899" filter="url(#ic5-ng)"/>
      <circle cx="39" cy="42" r="3" fill="#ec4899" filter="url(#ic5-ng)"/>
    </g>
    <path d="M30 4 C18 4 9 13 9 25 C9 33 13 40 20 44 L20 50 C20 52 22 54 24 54 L36 54 C38 54 40 52 40 50 L40 44 C47 40 51 33 51 25 C51 13 42 4 30 4 Z"
      fill="none" stroke="url(#ic5-bd)" strokeWidth="1.5" filter="url(#ic5-glow)"/>
    <path d="M30 6 C20 6 11 14 11 24 L13 23 C13 15 20 8 30 8 C40 8 47 15 47 23 L49 24 C49 14 40 6 30 6 Z"
      fill="#fff" opacity="0.07"/>
  </svg>
);

const CardIcon = () => (
  <svg viewBox="0 0 60 60" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic2-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#150d2e"/>
        <stop offset="100%" stopColor="#0e0820"/>
      </linearGradient>
      <linearGradient id="ic2-bd" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#c4b5fd"/>
        <stop offset="50%" stopColor="#8b5cf6"/>
        <stop offset="100%" stopColor="#6d28d9"/>
      </linearGradient>
      <filter id="ic2-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <rect x="5" y="13" width="50" height="34" rx="5" fill="url(#ic2-bg)"/>
    <rect x="5" y="13" width="50" height="34" rx="5"
      fill="none" stroke="url(#ic2-bd)" strokeWidth="1.5" filter="url(#ic2-glow)"/>
    <rect x="5" y="19" width="50" height="8" fill="#7c3aed" opacity="0.45"/>
    <rect x="12" y="31" width="11" height="9" rx="2" fill="#a78bfa" opacity="0.9"/>
    <line x1="15.5" y1="31" x2="15.5" y2="40" stroke="#6d28d9" strokeWidth="0.9"/>
    <line x1="19.5" y1="31" x2="19.5" y2="40" stroke="#6d28d9" strokeWidth="0.9"/>
    <line x1="12" y1="35.5" x2="23" y2="35.5" stroke="#6d28d9" strokeWidth="0.9"/>
    <circle cx="30" cy="36" r="1.8" fill="#8b5cf6" opacity="0.7"/>
    <circle cx="35.5" cy="36" r="1.8" fill="#8b5cf6" opacity="0.7"/>
    <circle cx="41" cy="36" r="1.8" fill="#8b5cf6" opacity="0.7"/>
    <circle cx="46.5" cy="36" r="1.8" fill="#8b5cf6" opacity="0.7"/>
    <path d="M7 15 L53 15 L53 19 C43 17 17 17 7 19 Z" fill="#fff" opacity="0.06"/>
  </svg>
);

const GearIcon = () => (
  <svg viewBox="0 0 60 60" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic6-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#031a1f"/>
        <stop offset="100%" stopColor="#021215"/>
      </linearGradient>
      <linearGradient id="ic6-bd" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#67e8f9"/>
        <stop offset="50%" stopColor="#06b6d4"/>
        <stop offset="100%" stopColor="#0e7490"/>
      </linearGradient>
      <filter id="ic6-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <circle cx="30" cy="30" r="26" fill="url(#ic6-bg)"/>
    <circle cx="30" cy="30" r="26" fill="none" stroke="url(#ic6-bd)" strokeWidth="1.5" filter="url(#ic6-glow)"/>
    <path d="M4 22 A26 26 0 0 1 56 22 L54 24 A24 24 0 0 0 6 24 Z" fill="#fff" opacity="0.06"/>
    {/* Gear body ring */}
    <circle cx="30" cy="30" r="15" fill="#06b6d4" opacity="0.1"/>
    <circle cx="30" cy="30" r="15" fill="none" stroke="#06b6d4" strokeWidth="1.5" filter="url(#ic6-glow)"/>
    {/* 8 teeth */}
    {[0, 45, 90, 135, 180, 225, 270, 315].map(angle => (
      <rect key={angle} x="27.5" y="8" width="5" height="7" rx="1"
        fill="#06b6d4" opacity="0.9"
        filter="url(#ic6-glow)"
        transform={`rotate(${angle}, 30, 30)`}/>
    ))}
    {/* Hub */}
    <circle cx="30" cy="30" r="7" fill="#031a1f"/>
    <circle cx="30" cy="30" r="7" fill="none" stroke="#67e8f9" strokeWidth="1" opacity="0.5"/>
    <circle cx="30" cy="30" r="3" fill="#06b6d4" opacity="0.6" filter="url(#ic6-glow)"/>
  </svg>
);

const MedalIcon = () => (
  <svg viewBox="0 0 60 60" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic4-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1f1405"/>
        <stop offset="100%" stopColor="#140d03"/>
      </linearGradient>
      <linearGradient id="ic4-rib" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f59e0b"/>
        <stop offset="100%" stopColor="#b45309"/>
      </linearGradient>
      <linearGradient id="ic4-bd" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#fde68a"/>
        <stop offset="50%" stopColor="#f59e0b"/>
        <stop offset="100%" stopColor="#b45309"/>
      </linearGradient>
      <filter id="ic4-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <path d="M24 5 L24 20 L30 24 L36 20 L36 5 Z" fill="url(#ic4-rib)" opacity="0.9"/>
    <line x1="24" y1="5" x2="36" y2="5" stroke="#fbbf24" strokeWidth="1" opacity="0.5"/>
    <circle cx="30" cy="40" r="18" fill="url(#ic4-bg)"/>
    <circle cx="30" cy="40" r="18" fill="none" stroke="url(#ic4-bd)" strokeWidth="1.5" filter="url(#ic4-glow)"/>
    <circle cx="30" cy="40" r="15" fill="none" stroke="#f59e0b" strokeWidth="0.5" opacity="0.3"/>
    <path d="M20,40 L26,46 L40,32"
      fill="none" stroke="#fef3c7" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" filter="url(#ic4-glow)"/>
    <path d="M14 34 A18 18 0 0 1 46 34 L44 35 A16 16 0 0 0 16 35 Z" fill="#fff" opacity="0.07"/>
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 60 60" width="64" height="64" fill="none">
    <defs>
      <linearGradient id="ic3-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#071f18"/>
        <stop offset="100%" stopColor="#041510"/>
      </linearGradient>
      <linearGradient id="ic3-bd" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#6ee7b7"/>
        <stop offset="50%" stopColor="#10b981"/>
        <stop offset="100%" stopColor="#047857"/>
      </linearGradient>
      <filter id="ic3-glow">
        <feGaussianBlur stdDeviation="1.5" result="b"/>
        <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <circle cx="30" cy="30" r="26" fill="url(#ic3-bg)"/>
    <circle cx="30" cy="30" r="26" fill="none" stroke="url(#ic3-bd)" strokeWidth="1.5" filter="url(#ic3-glow)"/>
    <path d="M4 22 A26 26 0 0 1 56 22 L54 24 A24 24 0 0 0 6 24 Z" fill="#fff" opacity="0.06"/>
    <path d="M30,12 A18,18 0 1 1 12,30"
      fill="none" stroke="#6ee7b7" strokeWidth="3" strokeLinecap="round" filter="url(#ic3-glow)"/>
    <polygon points="9,30 15,30 12,36" fill="#6ee7b7" filter="url(#ic3-glow)"/>
    <polygon points="30,9 30,15 36,12" fill="#6ee7b7" filter="url(#ic3-glow)"/>
  </svg>
);

type TrustItem = {
  Icon: () => JSX.Element;
  title: string;
  sub: string;
  color: string;
};

const ITEMS: TrustItem[] = [
  { Icon: LockIcon,  title: 'Daten in Deutschland', sub: 'DSGVO-konform',       color: '#3b82f6' },
  { Icon: HeadIcon,  title: 'KI-gestützt',           sub: 'State of the Art',   color: '#ec4899' },
  { Icon: CardIcon,  title: 'Sichere Zahlung',        sub: 'SSL + Stripe',       color: '#8b5cf6' },
  { Icon: GearIcon,  title: 'Automatisierung',        sub: 'Workflows & Prozesse', color: '#06b6d4' },
  { Icon: MedalIcon, title: '30 Tage Geld-zurück',    sub: 'Ohne Wenn und Aber', color: '#f59e0b' },
  { Icon: ArrowIcon, title: 'Jederzeit kündbar',      sub: 'Keine Bindung',      color: '#10b981' },
];

export default function TrustSection() {
  return (
    <section style={{ background: '#0a0a0f' }} className="px-6 md:px-12 pb-16 pt-10">
      <style>{`
        @property --angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
        @keyframes spin-border {
          to { --angle: 360deg; }
        }
        [data-trust-wrapper] {
          position: relative;
          border-radius: 14px;
          padding: 1px;
          background: rgba(255,255,255,0.1);
        }
        [data-trust-wrapper]::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 14px;
          background: conic-gradient(
            from var(--angle),
            transparent 70%,
            var(--glow-color) 85%,
            transparent 95%
          );
          opacity: 0;
          transition: opacity 0.3s;
          animation: spin-border 2s linear infinite;
        }
        [data-trust-wrapper]:hover::before { opacity: 1; }
        [data-trust-wrapper]::after {
          content: '';
          display: none;
        }
        [data-trust-inner] svg { width: 48px; height: 48px; }
        [data-trust-card] {
          position: relative;
          border-radius: 13px;
          padding: 16px 12px;
          background:
            radial-gradient(ellipse at 30% 15%, rgba(255,255,255,0.14) 0%, transparent 55%),
            linear-gradient(135deg, #18182200 0%, #0e0e16 100%),
            #111118;
          overflow: hidden;
          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.32),
            inset 0 -1px 0 rgba(0,0,0,0.4),
            inset 0 0 40px rgba(255,255,255,0.07);
        }
        [data-trust-orbit] {
          position: absolute;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: var(--glow-color);
          filter: blur(22px);
          opacity: 0;
          transition: opacity 0.3s;
          pointer-events: none;
          z-index: 0;
          left: calc(50% + 45% * cos(var(--angle) + 216deg));
          top:  calc(50% + 45% * sin(var(--angle) + 216deg));
          transform: translate(-50%, -50%);
          animation: spin-border 2s linear infinite;
        }
        [data-trust-wrapper]:hover [data-trust-orbit] { opacity: 0.4; }
        [data-trust-inner] { position: relative; z-index: 1; }
        @keyframes trust-fade-in {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        [data-trust-grid] {
          display: grid;
          grid-template-columns: repeat(6, minmax(0, 1fr));
          gap: 14px;
          width: 100%;
        }
        [data-trust-wrapper] {
          animation: trust-fade-in 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
          min-width: 0;
        }
        [data-trust-wrapper]:nth-child(1) { animation-delay: 1.1s; }
        [data-trust-wrapper]:nth-child(2) { animation-delay: 1.4s; }
        [data-trust-wrapper]:nth-child(3) { animation-delay: 1.7s; }
        [data-trust-wrapper]:nth-child(4) { animation-delay: 2.0s; }
        [data-trust-wrapper]:nth-child(5) { animation-delay: 2.3s; }
        [data-trust-wrapper]:nth-child(6) { animation-delay: 2.6s; }
        @media (max-width: 560px) {
          [data-trust-grid] { grid-template-columns: 1fr 1fr; }
        }
      `}</style>

      <div data-trust-grid>
        {ITEMS.map((item) => (
          <div
            key={item.title}
            data-trust-wrapper
            style={{ '--glow-color': item.color } as CSSProperties}
          >
            <div data-trust-card>
              <span data-trust-orbit aria-hidden="true" />
              <div data-trust-inner style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'center' }}>
                  <item.Icon />
                </div>
                <h3 style={{ fontSize: '0.82rem', fontWeight: 700, color: '#e2e8f0', marginBottom: 3 }}>
                  {item.title}
                </h3>
                <p style={{ fontSize: '0.71rem', color: '#64748b', lineHeight: 1.4 }}>
                  {item.sub}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
